var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions-button-wrapper-999"},[_vm._t("videomarkinmarkout")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }